module.exports = __webpack_public_path__ + "img/procedural-terrain3.320939bf.png";